import React, { useCallback, useMemo } from 'react';
import { Box, CardPurseIcon, CardTypesEnum, Hint, InfoOutlineIcon, Text } from '@common-fe/common-fe';
import _ from 'lodash';
import styled from 'styled-components';

import { EnrolledBlockPlanCategoriesItem } from '../Dashboard.type';
const StyledInfoIcon = styled(InfoOutlineIcon)`
  cursor: pointer;
  opacity: 0.5;
  transition: all 0.3s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;
const TITLES = {
  [CardTypesEnum.HSA]: 'HSA',
  [CardTypesEnum.MEDICAL]: 'Medical',
  [CardTypesEnum.DENTAL]: 'Dental',
  [CardTypesEnum.VISION]: 'Vision',
  [CardTypesEnum.RX]: 'RX',
  [CardTypesEnum.HCFSA]: 'HCFSA',
  [CardTypesEnum.DCAP]: 'DCAP',
  [CardTypesEnum.HRA]: 'HRA',
  [CardTypesEnum.TRANSIT]: 'Transit',
  [CardTypesEnum.ADOPTION]: 'Adoption',
  [CardTypesEnum.PARKING]: 'Parking',
  [CardTypesEnum.LIFESTYLE]: 'Lifestyle',
  [CardTypesEnum.SPECIALTY]: 'Specialty',
  [CardTypesEnum.TRAVEL]: 'Travel',
};
interface Props {
  items?: EnrolledBlockPlanCategoriesItem[];
}
const EnrolledBlockPlans: React.FC<Props> = ({ items }) => {
  const getText = useCallback((category: CardTypesEnum) => {
    if (!category) {
      return '';
    }
    const found = _.get(TITLES, category);
    if (found) {
      return found;
    }
    return _.replace(_.capitalize(category), '_', ' ');
  }, []);

  const isEmpty = useMemo(() => {
    return _.isEmpty(items);
  }, [items]);

  if (!items || isEmpty) {
    return null;
  }

  return (
    <Hint
      data-testid="dashboard_banner_enrolled-block-plans"
      backgroundColor="canvas"
      hintElevation="default"
      hintAlign="bottom"
      style={{ margin: 0 }}
      hintElement={
        <Box margin={{ left: 'xxxs', top: '1px' }}>
          <StyledInfoIcon
            data-testid="dashboard_banner_enrolled-block-plans_info-icon"
            size="16px"
            color="iconOnColor"
          />
        </Box>
      }
      isHintHeightLimitless
    >
      <div>
        <Box direction="column">
          <Text
            data-testid="dashboard_banner_enrolled-block-plans_title"
            size="medium"
            color="textBody"
            weight={700}
            margin={{ bottom: 'spacing8' }}
          >
            Actively enrolled:
          </Text>

          {items &&
            items.map((item) => (
              <div
                key={item.accountType}
                data-testid={`dashboard_banner_enrolled-block-plans_item-${item.accountType}`}
              >
                <Box direction="row" height="32px" margin={{ bottom: 'spacing4' }} align="center">
                  <Box width="24px" height="24px" align="center" justify="center">
                    <CardPurseIcon size="24px" type={item.accountType} />
                  </Box>
                  <Box margin={{ left: 'spacing8' }}>
                    <Text
                      data-testid={`dashboard_banner_enrolled-block-plans_category-${item.accountType}`}
                      size="medium"
                      weight={400}
                      truncate
                      title={item.accountName}
                      color="textBody"
                    >
                      {getText(item.accountType)}
                    </Text>
                  </Box>
                  <Text
                    data-testid={`dashboard_banner_enrolled-block-plans_count-${item.accountType}`}
                    size="medium"
                    margin={{ left: 'auto' }}
                    weight={400}
                    color="textBody"
                  >
                    {item.count}
                  </Text>
                </Box>
              </div>
            ))}
        </Box>
      </div>
    </Hint>
  );
};

export default EnrolledBlockPlans;
